import React from 'react';
import _ from 'lodash';
import { Button, Card } from 'semantic-ui-react';

import TeamMember from '../../components/team-member';

const leftFloatedStyle = {
  float: 'left',
  display: 'block',
  paddingTop: 8,
};

const KASPERSKY = 'ec3b6d8e-f9f0-42f4-9c09-294368cbe683';
const ROLE_BASED_ORGS = [
  KASPERSKY,
];

const MembersTab = props => {
  const openAddTeamMemberModal = _.get(props, 'children.openAddTeamMemberModal', _.noop);
  const handleDeleteConfirmation = _.get(props, 'children.handleDeleteConfirmation', _.noop);
  const members = _.get(props, 'members', []);
  const filteredMembers = _.reject(members, m => (m.email.match(/@dyzio.co/)));
  const userInfo = _.get(props, 'children.userInfo');
  const organisation = _.get(props, 'children.organisation');
  const { isUserSuperAdmin } = userInfo;

  const isRoleBasedOrganisation = organisation && _.includes(ROLE_BASED_ORGS, organisation.id);
  const showAddTeamMemberButton = isRoleBasedOrganisation ? isUserSuperAdmin : true;
  return (
    <Card fluid>
      <Card.Content>
        <h3 style={leftFloatedStyle}>Team Members ({filteredMembers.length})</h3>
        {
          showAddTeamMemberButton &&
          <Button
            icon="plus"
            color="pink"
            content="Add a team member"
            floated="right"
            onClick={openAddTeamMemberModal}
          />
        }
      </Card.Content>
      <Card.Content>
        <Card.Group itemsPerRow={4}>
          {
            _.map(filteredMembers, member => (
              <TeamMember
                key={member.id}
                member={member}
                buttonClickHandler={handleDeleteConfirmation}
              />
            ))
          }
        </Card.Group>
      </Card.Content>
    </Card>
  );
};

export default MembersTab;



/** WEBPACK FOOTER **
 ** ./src/containers/team-manager/members-tab.js
 **/